import AriaLiveAnnoucer from './AriaLiveAnnoucer';

export default AriaLiveAnnoucer;